import React from "react";

import { DeliveryTypes, StorageKeys } from "@utils/enums";

import { TPreferredStoreState } from "@redux/modules/api/data/preferredStore/preferredStore.types";

import { AdditionalServiceModel } from "lib/@types/service/shared";

import {
    DeliveryOption,
    ECommerceProduct,
    Tooltips,
} from "../../eCommerce.types";
import "./deliveryBlock.scss";
import DeliveryItem from "./deliveryItem/deliveryItem.component";

type Props = {
    handleClick: (type: DeliveryTypes) => void;
    activeDelivery: string;
    onServiceProductClick: (
        serviceProduct: AdditionalServiceModel,
        deliveryType: DeliveryTypes,
    ) => void;
    activeServiceProducts: string[];
    options: Array<DeliveryOption>;
    preferredStore?: TPreferredStoreState | null;
    minimumOrderQuantity: number;
    roundingValue: number;
    xfPath?: string | null;
    tooltips: Tooltips;
    infoLink: string;
    isLimitedStock: boolean;
    product?: ECommerceProduct;
    deliveryTypesDisabled: boolean;
};

const DeliveryBlock = ({
    handleClick,
    activeDelivery,
    onServiceProductClick,
    activeServiceProducts,
    options,
    preferredStore,
    roundingValue,
    minimumOrderQuantity,
    xfPath,
    tooltips,
    infoLink,
    isLimitedStock,
    product,
    deliveryTypesDisabled,
}: Props) => {
    const onClick = (type: DeliveryTypes) => {
        sessionStorage.setItem(StorageKeys.DeliveryType, type);
        handleClick && handleClick(type);
    };

    return (
        <div className="w-100">
            <div className="delivery-block" data-test="deliveryBlock">
                {options.map(option => {
                    return (
                        <div key={option.deliveryType}>
                            <DeliveryItem
                                data-test="deliveryItem"
                                option={option}
                                handleClick={onClick}
                                onServiceProductClick={serviceProduct =>
                                    onServiceProductClick(
                                        serviceProduct,
                                        option.deliveryType,
                                    )
                                }
                                activeServiceProducts={activeServiceProducts}
                                checked={option.deliveryType === activeDelivery}
                                preferredStore={preferredStore}
                                roundingValue={roundingValue}
                                xfPath={xfPath}
                                minimumOrderQuantity={minimumOrderQuantity}
                                isLimitedStock={isLimitedStock}
                                tooltips={tooltips}
                                infoLink={infoLink}
                                product={product}
                                deliveryTypesDisabled={deliveryTypesDisabled}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DeliveryBlock;
